import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IPriceListResponseCruises,
  PriceType,
} from '../../../../../interfaces/src/lib/interfaces/index';

const initialState: IPriceListResponseCruises = {
  priceTypes: null,
};

const priceTypesSlice = createSlice({
  name: 'priceTypes',
  initialState,
  reducers: {
    setPriceTypes: (state: IPriceListResponseCruises, action: PayloadAction<PriceType[]>) => {
      state.priceTypes = action.payload;
    },
  },
});

export const { setPriceTypes } = priceTypesSlice.actions;
export default priceTypesSlice.reducer;
